import { FC, useEffect, useMemo, useState } from 'react';
import './TableInventory.css';
import eFormType from '../../../main/assets/enums/eFormType';
import { useForm } from 'react-hook-form';
import GeneralInput from '../../../main/components/generalInput/GeneralInput';
import React from 'react';
import ITable from '../../../main/interfaces/ITable';
import IRow from '../../../main/interfaces/IRow';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import { toast } from 'react-toastify';
import axiosInstance from '../../../main/initializers/axios';
import GeneralSelect from '../../../main/components/select/GeneralSelect';
import useGetEnums from '../../../main/hooks/useGetEnums/index';
import { useTranslation } from 'react-i18next';

interface Props {
  tempProduct?: any;
  rows?: IRow[];
  modalType: eFormType;
  onSubmitData: () => void;
  createOrUpdate: boolean;
}

const TableInventory: FC<Props> = (props: Props) => {
  const { tempProduct, rows, modalType, createOrUpdate } = props;
  const allEnums = useGetEnums();

  const { i18n } = useTranslation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ITable>({
    defaultValues: {
      id: modalType === eFormType.Edit ? tempProduct?.id : 0,
      code: modalType === eFormType.Edit ? tempProduct?.code : '',
      name: modalType === eFormType.Edit ? tempProduct?.name : '',
      isBusy: modalType === eFormType.Edit ? tempProduct?.isBusy : false,
      rowId: modalType === eFormType.Edit ? tempProduct?.rowId : 0,
      tableType: modalType === eFormType.Edit ? tempProduct?.tableType : 0,
      rotation: modalType === eFormType.Edit ? tempProduct?.rotation : 0,
    },
  });

  const onSubmit = async (data: any) => {
    const params = {
      id: data.id,
      code: data.code,
      name: data.name,
      isBusy: data.isBusy ?? false,
      RowId: data.rowId,
      tableType: data.tableType,
      rotation: data.rotation,
    };
    try {
      const response = await axiosInstance.post(ApiConstants.tables.update, params);

      if (response.status === 200) {
        toast.success(i18n.t('orderDetails.createdSuccessfully'));
        props.onSubmitData();
      } else {
        toast.error(i18n.t('orderDetails.somethingWentWrong'));
      }
    } catch (e) {
      toast.error(i18n.t('orderDetails.somethingWentWrong'));
    }
  };

  useEffect(() => {
    if (createOrUpdate) {
      handleSubmit(onSubmit)();
    }
  }, [createOrUpdate]);
  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-sm-12">
          <div className="form-row formRowCDR">
            <div className="form-group  col-md-6 formInputStyle">
              <GeneralInput
                required={true}
                label={i18n.t('generic.code')}
                name="code"
                type="text"
                errors={errors}
                placeholder={i18n.t('generic.code')}
                control={control}
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={true}
                label={i18n.t('generic.name')}
                name="name"
                type="text"
                errors={errors}
                placeholder={i18n.t('generic.name')}
                control={control}
              />
            </div>
          </div>
          <div className="form-row formRowCDR">
            <div className="form-group  col-md-6 formInputStyle">
              <GeneralSelect
                preSelectedVal={i18n.t('tableDetails.selectType')}
                setSelectedVal={(val) => console.log(val)}
                data={allEnums.TableType}
                translationTag="enum.tableType"
                required={true}
                errors={errors}
                control={control}
                label={i18n.t('tableDetails.tabbleType')}
                name="tableType"
                value="name"
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                label={i18n.t('tableDetails.rotation')}
                name="rotation"
                type="text"
                errors={errors}
                placeholder={i18n.t('tableDetails.rotation')}
                control={control}
              />
            </div>
          </div>
          <div className="form-row formRowCDR">
            <GeneralSelect
              preSelectedVal={i18n.t('generic.addRows')}
              setSelectedVal={(val) => console.log(val)}
              data={rows}
              required={true}
              control={control}
              label={i18n.t('generic.rows')}
              name="rowId"
              value="name"
              errors={errors}
            />
            <GeneralInput
              label={i18n.t('tableDetails.isBusy')}
              name="isBusy"
              type="checkbox"
              placeholder={i18n.t('tableDetails.isBusy')}
              errors={errors}
              control={control}
            />
          </div>
          <hr />
        </div>
      </form>
    </div>
  );
};

export default TableInventory;
